export enum StepColor {
  Gray = '#888888',
  Yellow = '#FBBD08',
  Lime = '#B5CC18',
  Green = '#21BA45',
}
